import {AiComposerApplyMode, AiComposerDraft} from './AiComposerDraft';
import {appendProposedBody} from './appendProposedBody';

/**
 * A subject the employee wrote, or one the form filled in ("Re: …", a template), survives every
 * apply. `canReplaceSubject` is `true` only while the subject is empty or the assistant wrote it.
 */
// eslint-disable-next-line max-params -- Pre-existing violation
export const buildAppliedDraft = (
  previous: AiComposerDraft,
  proposedBody: string,
  proposedSubject: string | undefined,
  mode: AiComposerApplyMode,
  isHtml: boolean,
  canReplaceSubject: boolean
): AiComposerDraft => {
  const previousSubject = previous.subject ?? '';
  const subject =
    canReplaceSubject || previousSubject.trim() === ''
      ? (proposedSubject ?? previousSubject)
      : previousSubject;

  if (mode === 'insertBelow') {
    return {
      body: appendProposedBody(previous.body, proposedBody, isHtml),
      subject: previousSubject.trim() === '' ? (proposedSubject ?? '') : previousSubject,
    };
  }

  return {body: proposedBody, subject};
};
